import React from "react";

const plans = [
  {
    tier: "STANDARD",
    price: "10,000",
    features: [
      "Instagram + Facebook Management",
      "10 Posts/Reels per Month",
      "Content Planning",
      "Captions, Hashtags & CTA",
      "Posting & Scheduling",
      "Basic Audience Engagement",
      "Facebook & Instagram Ads Management",
      "Basic Ads Monitoring",
      "Monthly Performance Report",
      "Marketing Guidance",
      "Client's Graphic Designer & Video Editor",
    ],
  },
  {
    tier: "GROWTH",
    price: "20,000",
    highlight: true,
    features: [
      "Instagram + Facebook Management",
      "15 Posts/Reels per Month",
      "Complete Content Strategy",
      "Captions, Hashtags & CTA",
      "Posting & Scheduling",
      "Active Audience Engagement",
      "Facebook & Instagram Ads Management",
      "Multiple Ad Campaigns",
      "Ad Optimization & Testing",
      "Audience & Targeting Testing",
      "Lead Generation Campaigns",
      "Retargeting Campaigns",
      "Detailed Analytics",
      "Weekly Performance Review",
      "Advanced Marketing Strategy",
      "Client's Graphic Designer & Video Editor",
    ],
  },
];

const SocialMediaMarketing = () => {
  return (
    <div className="mt-16 max-w-5xl mx-auto px-6 lg:px-8">
      <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
        <span className="w-1.5 h-6 bg-primary rounded-full"></span>
        Social Media Marketing
      </h2>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5">
        {plans.map((plan, idx) => (
          <div
            key={idx}
            className={`bg-card rounded-xl p-6 brand-shadow border flex flex-col ${
              plan.highlight
                ? "border-primary/50"
                : "border-border/40"
            }`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`text-[10px] font-bold tracking-wider px-2.5 py-1 rounded-full ${
                  plan.highlight
                    ? "bg-primary/10 text-primary"
                    : "bg-surface text-muted-foreground border border-border"
                }`}
              >
                {plan.tier}
              </span>
              {plan.highlight && (
                <span className="text-[10px] font-bold tracking-wider text-primary">
                  MOST POPULAR
                </span>
              )}
            </div>

            <div className="mt-4 flex items-baseline gap-1">
              <span className="text-3xl font-bold text-foreground">
                ₹{plan.price}
              </span>
              <span className="text-sm font-semibold text-muted-foreground">
                / month
              </span>
            </div>

            <ul className="mt-5 space-y-2.5 flex-1">
              {plan.features.map((feature, fIdx) => (
                <li
                  key={fIdx}
                  className="flex items-start gap-2 text-sm text-foreground"
                >
                  <svg
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-4 h-4 mt-0.5 shrink-0 text-primary"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.704 5.29a1 1 0 010 1.42l-7.5 7.5a1 1 0 01-1.42 0l-3.5-3.5a1 1 0 111.42-1.42L8.5 12.09l6.79-6.8a1 1 0 011.42 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mt-5 pt-4 border-t border-border/30">
              <span className="text-xs font-semibold text-muted-foreground">
                Ad Budget Separate
              </span>
            </div>
          </div>
        ))}
      </div>

      <p className="mt-4 text-sm text-muted-foreground">
        * Graphic Designing and Video Editing are not included in the
        package. These services will be handled by the client's respective
        team members. Advertising budget is separate from the monthly
        management fee.
      </p>
    </div>
  );
};

export default SocialMediaMarketing;